import { render, staticRenderFns } from "./FamousPediaRead.vue?vue&type=template&id=01ae7306&"
import script from "./FamousPediaRead.vue?vue&type=script&lang=js&"
export * from "./FamousPediaRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports